import * as React from "react";
import { If } from "../../core/components/If";
import { IComponentDataItem } from "../../core/types/IComponentDataItem";
import { IFileSystem } from "../../dataingestion/types/IFileSystem";
import { IStoragePathItemData } from "../../dataingestion/types/IStoragePathItemData";
import { ILookupInstance } from "../../lookup/types/ILookup";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { CleanUploadFilesState, addFileToUpload, setInDropZone, setProgressUploadFileProccess, sortColumn, updatePagination } from "../../redux/reducers/DataIngestionReducer";
import {
    addDroppedFile,
    cleanDroppedFilesRepertoireState,
    setEditableFields, setProgressUploadFileRepertoireProccess
} from "../../redux/reducers/MembersPortalReducer";
import {
    hideModal,
    showModal,
    showYesNoPrompt
} from "../../redux/reducers/ModalReducer";
import { FormatFields } from "../../redux/types/FormatFields";
import { IAttachedFile } from "../../redux/types/IAttachedFile";
import IDroppedFiles from "../../redux/types/IDroppedFiles";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { IPaginationDetail } from "../../redux/types/IPaginationDetail";
import IRepertoireComponentDataItem from "../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import { DataSource } from "../../repertoire/types/DataSource";
import { ITreeData } from "../../repertoire/types/ITreeData";
import UploadCueSheetsMaintenanceGeneralDataView from "./components/uploadCueSheetsMaintenanceGeneralDataView/UploadCueSheetsMaintenanceGeneralDataView";
import UploadCueSheetsMaintenanceToolbar from "./components/uploadCueSheetsMaintenanceToolbar/UploadCueSheetsMaintenanceToolbar";
import { IMembersPortalPathInfo } from "../types/IMembersPortalPathInfo";

export interface IUploadCueSheetsPageProps {
    uploadCueSheetsMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem;
    uploadCueSheetsMaintenanceToolbarData?: IMembersPortalComponentDataItem;
    uploadCueSheetsMaintenanceGridsViewData?: IMembersPortalComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    activeTab: number;
    tabs: ITabReduxItem[];
    dataSource: DataSource;
    lookupValues?: ILookupDictionary;
    hideModal: typeof hideModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    resetMessageBanner: () => void;
    showModal: typeof showModal;
    clearModalSearchResults: () => void;
    incrementTempID?: () => void;
    containerDetailsWindowComponentData: IComponentDataItem;
    formats: ILookupInstance[];
    destinations: ILookupInstance[];
    selectedFileSystem: IFileSystem;
    droppedFiles: IDroppedFiles;
    setInDropZone: typeof setInDropZone;
    addFileToUpload: typeof addFileToUpload;
    isDropZone: boolean;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    storagePaths: IStoragePathItemData[];
    storagePathItemData: IComponentDataItem;
    refreshDirectory: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    addRepertoireAttachmentToState: (attachedFile: IAttachedFile) => void;
    attachedInputFiles: IStoragePathItemData[];
    attachedErrorsFiles: IStoragePathItemData[];
    attachedArchiveFiles: IStoragePathItemData[];
    removeWorkAttachmentIfExists: (attachedFile: IAttachedFile, source: DataSource) => void;
    workAttachmentsDropped?: IDroppedFiles;
    addDroppedFileRepertoire?: typeof addDroppedFile;
    setProgressUploadFileRepertoire: typeof setProgressUploadFileRepertoireProccess;
    cleanDroppedFilesRepertoire: typeof cleanDroppedFilesRepertoireState;
    paginationDetails: IPaginationDetail[];
    updatePagination: typeof updatePagination;
    sortColumn: typeof sortColumn;
    getDataIngestionComponentData?: () => void;
    getFilesystems?: (isRepertoireModule?: boolean) => void;
    refreshWorkDetails: (dataSource: string, workID: number, lookups: ILookupDictionary, otherIndicatorsWorkFlagTypes: string[], activeTabItem: ITabReduxItem, readonlyIndicatorsWorkFlagTypes: string[], formats?: FormatFields[]) => void;
    stepsCurrent?: number;
    stepsSetCurrent?: (current: number) => void;
    currentUser: string;
    portalType: string;
    currentUserNameNumber: string;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location, tabs?: ITabReduxItem[], lookupValues?: ILookupDictionary) => void;
    updatedScroll?: number;
    sources: ITreeData[];
    getUploadCueSheetsFiles: (currentUserNameNumber: string) => void;
    setCurrentPage: (link: string) => void;
    addTab: (tab: ITabReduxItem) => void;
    saveResultData: IMembersPortalComponentDataItem;
}


interface IUploadCueSheetsPagePropsState {
    toolbarWidth: number;
    isBulkCheckboxActive?: boolean;
    loading: boolean;
}

export class UploadCueSheetsPage extends React.PureComponent<
    IUploadCueSheetsPageProps,
    IUploadCueSheetsPagePropsState
> {
    toolbarParentRef;
    constructor(props: IUploadCueSheetsPageProps) {
        super(props);
        this.state = {
            toolbarWidth: null,
            isBulkCheckboxActive: false,
            loading: true
        };

        this.toolbarParentRef = React.createRef();
    }

    componentDidMount() {
        const {
            getFilesystems,
            getDataIngestionComponentData,
            containerDetailsWindowComponentData,
        } = this.props;
        if (!containerDetailsWindowComponentData || !containerDetailsWindowComponentData.fields || containerDetailsWindowComponentData.fields.length === 0) {
            getDataIngestionComponentData();
        }
        getFilesystems(true);
        CleanUploadFilesState();
    }

    componentDidUpdate() {
        const { uploadCueSheetsMaintenanceGeneralDataViewData, uploadCueSheetsMaintenanceGridsViewData, containerDetailsWindowComponentData } = this.props;

        if (uploadCueSheetsMaintenanceGeneralDataViewData && uploadCueSheetsMaintenanceGeneralDataViewData.fields && uploadCueSheetsMaintenanceGeneralDataViewData.fields.length > 0
            && uploadCueSheetsMaintenanceGridsViewData && uploadCueSheetsMaintenanceGridsViewData.fields && uploadCueSheetsMaintenanceGridsViewData.fields.length > 0
            && containerDetailsWindowComponentData && containerDetailsWindowComponentData.fields && containerDetailsWindowComponentData.fields.length > 0) {
            this.setState({ loading: false });
        }
    }

    resetMessageBanner() {
        const { resetMessageBanner } = this.props;
        resetMessageBanner();
    }

    refreshWorkDetails() {
        const { tabs, activeTab, lookupValues, dataSource } = this.props;
        let currentTab = tabs[activeTab];
        this.props.refreshWorkDetails(
            dataSource,
            currentTab.workMaintenanceState.work.workID,
            lookupValues,
            tabs[activeTab].otherIndicatorWorkFlagTypes,
            currentTab,
            tabs[activeTab].readonlyIndicatorWorkFlagTypes
        )
    }

    render() {
        const {
            containerDetailsWindowComponentData,
            tabs,
            activeTab,
            uploadCueSheetsMaintenanceGeneralDataViewData,
            uploadCueSheetsMaintenanceToolbarData,
            uploadCueSheetsMaintenanceGridsViewData,
            hideModal,
            showYesNoPrompt,
            dataGridTableData,
            showModal,
            incrementTempID,
            dataSource,
            currentUser,
            addFileToUpload,
            cleanUploadFilesState,
            destinations,
            droppedFiles,
            isDropZone,
            selectedFileSystem,
            setInDropZone,
            setProgressUploadFileProccess,
            sortColumn,
            storagePathItemData,
            attachedInputFiles,
            attachedErrorsFiles,
            attachedArchiveFiles,
            refreshDirectory,
            addRepertoireAttachmentToState,
            loadMembersPortalFromPath,
            removeWorkAttachmentIfExists,
            cleanDroppedFilesRepertoire,
            setProgressUploadFileRepertoire,
            paginationDetails,
            updatePagination,
            refreshWorkDetails,
            getDataIngestionComponentData,
            getUploadCueSheetsFiles,
            currentUserNameNumber,
            setCurrentPage,
            addTab,
            lookupValues,
            updatedScroll,
            saveResultData
        } = this.props;

        const changesMade = tabs[activeTab].changesMade || false;
        let readOnlyDataGridTableData = JSON.parse(JSON.stringify(dataGridTableData));

        const {
            toolbarWidth
        } = this.state;

        return (
            <div className="">
                <a target="_blank" id="downloadLinkDataIngestion"></a>
                <If condition={tabs[activeTab].versionNumber != null}>
                    <div><span>Version history number: {tabs[activeTab].versionNumber}</span></div>
                </If>

                <div id="toolbarContainer" className="WorkMaintenanceToolbar collapse" ref={this.toolbarParentRef}>
                    <UploadCueSheetsMaintenanceToolbar
                        changesMade={changesMade}
                        showYesNoPrompt={showYesNoPrompt}
                        showModal={showModal}
                        hideModal={hideModal}
                        resetMessageBanner={this.resetMessageBanner.bind(this)}
                        scroll={updatedScroll}
                        toolbarWidth={toolbarWidth}
                        toolbarData={uploadCueSheetsMaintenanceToolbarData}
                        saveResultData={saveResultData}
                        usage={null}
                        activeTab={activeTab}
                        tabs={tabs}
                        dataSource={dataSource}
                        isReadonly={false}
                        isNew={true}
                        lookupValues={lookupValues}
                        refreshUploadCueSheetsFiles={() => getUploadCueSheetsFiles(currentUserNameNumber)}
                        currentUser={currentUser}
                        currentUserNameNumber={currentUserNameNumber}
                    />
                </div>

                <div className="">
                    <UploadCueSheetsMaintenanceGeneralDataView
                        UploadCueSheetsMaintenanceGeneralDataViewData={uploadCueSheetsMaintenanceGeneralDataViewData}
                        usage={null}
                        isReadOnly={false}
                        lookupValues={lookupValues}
                        loadMembersPortalFromPath={loadMembersPortalFromPath}
                        showModal={showModal}
                        hideModal={hideModal}
                        activeTab={activeTab}
                        tabs={tabs}
                        resetMessageBanner={this.resetMessageBanner.bind(this)}
                        incrementTempID={incrementTempID}
                        editableFields={[]}
                        changesMade={changesMade}
                        setEditableFields={setEditableFields}
                        activeHeaderSection={tabs[activeTab].activeHeaderSection}
                        dataGridTableData={readOnlyDataGridTableData}
                        uploadCueSheetsMaintenanceGridsViewData={uploadCueSheetsMaintenanceGridsViewData}
                        addFileToUpload={addFileToUpload}
                        cleanUploadFilesState={cleanUploadFilesState}
                        containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                        destinations={destinations}
                        droppedFiles={droppedFiles}
                        isDropZone={isDropZone}
                        selectedFileSystem={selectedFileSystem}
                        setInDropZone={setInDropZone}
                        setProgressUploadFileProccess={setProgressUploadFileProccess}
                        sortColumn={sortColumn}
                        storagePathItemData={storagePathItemData}
                        attachedInputFiles={attachedInputFiles}
                        attachedErrorsFiles={attachedErrorsFiles}
                        attachedArchiveFiles={attachedArchiveFiles}
                        refreshDirectory={refreshDirectory}
                        paginationDetails={paginationDetails}
                        updatePagination={updatePagination}
                        addRepertoireAttachmentToState={addRepertoireAttachmentToState}
                        removeWorkAttachmentIfExists={removeWorkAttachmentIfExists}
                        cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
                        setProgressUploadFileRepertoire={setProgressUploadFileRepertoire}
                        refreshWorkDetails={refreshWorkDetails}
                        dataSource={dataSource}
                        getDataIngestionComponentData={getDataIngestionComponentData}
                        currentUserNameNumber={currentUserNameNumber}
                        setCurrentPage={setCurrentPage}
                        addTab={addTab}
                    />
                </div>
            </div>
        );
    }
}
